import {Action, Reducer} from 'redux';
import {
  POCTool,
  POCToolSummaryWebPortal,
  SuperPOCTool,
} from '../../models/IPOCToolWebPortal';
import {
  FETCHING_CONTENT_BY_MINITOOL_ID_WEBPORTAL,
  FETCHING_MINIPOCTOOL_BY_ID_WEBPORTAL,
  FETCHING_POCTOOL_BY_ID_WEBPORTAL,
  FETCHING_POCTOOL_SUMMARY_WEBPORTAL,
  KnownAction,
  SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FAILED,
  SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FULFILLED,
  SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FAILED,
  SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FULFILLED,
  SET_POCTOOL_BY_ID_WEBPORTAL_FAILED,
  SET_POCTOOL_BY_ID_WEBPORTAL_FULFILLED,
  SET_POCTOOL_SUMMARY_WEBPORTAL_FAILED,
  SET_POCTOOL_SUMMARY_WEBPORTAL_FULFILLED,
} from './POCToolsWebPortalActions';

export interface POCToolsWebPortalState {
  poctoolSummaries: POCToolSummaryWebPortal[];
  pointOfCareTool: POCTool;
  superPointOfCareTool: SuperPOCTool;
  isLoading: boolean;
  error: string;
}

export const reducer: Reducer<POCToolsWebPortalState> = (
  state: POCToolsWebPortalState | undefined,
  incomingAction: Action,
): POCToolsWebPortalState => {
  if (state === undefined) {
    return {
      isLoading: false,
      poctoolSummaries: [],
      pointOfCareTool: {
        id: '',
        name: '',
        lastUpdated: '',
        description: '',
        categories: [],
      },
      superPointOfCareTool: {
        id: '',
        name: '',
        lastUpdated: '',
        description: '',
        miniTools: [],
        categories: [],
      },
      error: '',
    };
  }
  const action = incomingAction as KnownAction;
  switch (action.type) {
    case FETCHING_POCTOOL_SUMMARY_WEBPORTAL:
      return {
        ...state,
        isLoading: true,
      };
    case SET_POCTOOL_SUMMARY_WEBPORTAL_FULFILLED:
      return {
        ...state,
        poctoolSummaries: action.summaries,
        isLoading: false,
      };
    case SET_POCTOOL_SUMMARY_WEBPORTAL_FAILED:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case FETCHING_POCTOOL_BY_ID_WEBPORTAL:
      return {
        ...state,
        isLoading: true,
      };
    case FETCHING_MINIPOCTOOL_BY_ID_WEBPORTAL:
      return {
        ...state,
        isLoading: true,
      };
    case FETCHING_CONTENT_BY_MINITOOL_ID_WEBPORTAL:
      return {
        ...state,
        isLoading: true,
      };
    case SET_POCTOOL_BY_ID_WEBPORTAL_FULFILLED:
      return {
        ...state,
        pointOfCareTool: action.pocTool,
        superPointOfCareTool: {
          id: '',
          name: '',
          lastUpdated: '',
          description: '',
          miniTools: [],
          categories: [],
        },
        isLoading: false,
      };
    case SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FULFILLED:
      return {
        ...state,
        pointOfCareTool: {
          id: '',
          name: '',
          lastUpdated: '',
          description: '',
          categories: [],
        },
        superPointOfCareTool: {
          id: action.superPocTool.id,
          name: action.superPocTool.name,
          lastUpdated: action.superPocTool.lastUpdated,
          categories: state.superPointOfCareTool.categories,
          description: action.superPocTool.description,
          miniTools: action.superPocTool.miniTools,
        },
        isLoading: false,
      };
    case SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FULFILLED:
      return {
        ...state,
        superPointOfCareTool: {
          ...state.superPointOfCareTool,
          categories: action.content,
        },
        isLoading: false,
      };

    case SET_POCTOOL_BY_ID_WEBPORTAL_FAILED:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FAILED:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FAILED:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    default:
      return state;
  }
};
